import addDOMEventListener from 'add-dom-event-listener';
import ReactDOM from 'react-dom';

export default function addEventListenerWrap(target, eventType, cb) {
  /* eslint camelcase: 2 */
  const callback = ReactDOM.unstable_batchedUpdates ? function run(e) {
    ReactDOM.unstable_batchedUpdates(cb, e);
  } : cb;
  return addDOMEventListener(target, eventType, callback);
}



// WEBPACK FOOTER //
// ./_rc-util-4.5.0/src/Dom/addEventListener.js